import { call, put, select } from 'redux-saga/effects';
import { getFttrAvailability as getFttrAvailabilityAda } from '@bitComponents/adabyron/product';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getFttrAvailability(params) {
  const { normalizeHttpErrors, reduxUpdate, data } = params;

  try {
    const context = yield select(contextStore);
    const response = yield call(getFttrAvailabilityAda, data, context);
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_FTTR_AVAILABILITY, error);

    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
